import PropTypes from 'prop-types';

export default {
  mileageInfo: PropTypes.object,
  className: PropTypes.string,
};
